import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Comparison } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-overlay-medium',
  templateUrl: './overlay-medium.component.html',
  styleUrls: ['./overlay-medium.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayMediumComponent {
  /**
   * Receives array of comparisons to compare
   */
  @Input() comparisons = [] as Comparison[];

  /**
   * Emits an object of type event back to the parent component when the overlay close is clicked
   */
  @Output() closed: EventEmitter<Event> = new EventEmitter();

  /**
   * Emits an object of type event back to the parent component when the card cta is selected
   */
  @Output() selected: EventEmitter<Event> = new EventEmitter();

  /**
   * Emits an object of type event back to the parent component when the card close is clicked
   */
  @Output() removed: EventEmitter<Event> = new EventEmitter();

  /**
   * Emits an object of type event back to the parent component when the compare now cta is clicked
   */
  @Output() compare: EventEmitter<void> = new EventEmitter();

  /**
   * Fires when overlay close is clicked - passes in event object
   */
  onClose(e: Event) {
    this.closed.emit(e);
  }

  /**
   * Fires when card component close is clicked to remove card - passes in event object
   */
  onRemove(e: Event) {
    this.removed.emit(e);
  }

  /**
   * Fires when card component close is clicked to remove card - passes in event object
   */
  onCompare() {
    this.compare.emit();
  }
}
